import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import auth from '../auth'
import api from '@api'
import routes from './modules/routes'
import { ROUTES } from '@router/modules/constants'
import { COMPLETE_SIGN_UP_STEP } from '@/constants/localStorageKeys'
import { isSignInSignUpPage } from '@router/modules/routesUtils'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

const onSuccess = (response) => {
  return response
}

const onError = (error) => {
  let answer = Promise.reject(error)
  if (error.response && error.response.status === 401) {
    if (error.response.config.url.indexOf('login') === -1) {
      const isPageInit = localStorage.getItem('is_page_init')
      api.auth.logoutForExpiredToken()
      if (isPageInit && router.app.$route.name !== ROUTES.SIGN_IN.name) {
        router.push({ name: ROUTES.SIGN_IN.name })
      }
      return answer
      // auth.refresh()
      //   .then((response) => {
      //     answer = Promise.resolve(error)
      //   })
      //   .catch(err => {
      //     api.auth.logoutForExpiredToken()
      //     answer = Promise.reject(error)
      //     throw err
      //   })
    } else {
      return answer
    }
  } else if (error.response && error.response.status === 403) {
    // Handle 403 errors for missing confirmation cookies during tenant signup
    const tenantSignupRoutes = [
      ROUTES.COMPLETE_SIGN_UP.name,
      ROUTES.ADD_AGENCY.name,
      ROUTES.INVITE_TEAMMATES.name,
      ROUTES.ADD_AGENCY_ATLASSIAN.name,
      ROUTES.INVITE_TEAMMATES_ATLASSIAN.name
    ]

    if (router.app && tenantSignupRoutes.includes(router.app.$route.name)) {
      // Show warning toast and redirect to sign-in
      router.app.$snotify.warning(
        'Sign-up session expired. Please reopen the link in your email to start over.',
        'Session Expired',
        { ...router.app.$store.state.snotify }
      )
      router.push({ name: ROUTES.SIGN_IN.name })
    }
    return answer
  } else {
    return answer
  }
}

axios.interceptors.response.use(onSuccess, onError)

const config = {
  tokenExpiredUserRegisterRouter: 'tokenExpired.userRegisterRouter',
  tokenNullUserUnregisterRouter: 'tokenNull.userUnregisterRouter',
  tokenReadyUserUnregisterRouter: 'tokenReady.userUnregisterRouter',
  tokenReadyUserRegisterRouter: 'tokenReady.userRegisterRouter'
}

const getTypeAction = (token, isUnRegisteredRoute) => {
  let state = ''

  if (!token) {
    if (!isUnRegisteredRoute) {
      state = config.tokenExpiredUserRegisterRouter
    } else {
      state = config.tokenNullUserUnregisterRouter
    }
  } else {
    if (isUnRegisteredRoute) {
      state = config.tokenReadyUserUnregisterRouter
    } else {
      state = config.tokenReadyUserRegisterRouter
    }
  }

  return state
}

router.beforeEach((to, from, next) => {
  if (to.name === ROUTES.AVAILABLE_PROFILES.name) {
    next()
    return
  }

  const token = localStorage.getItem('access_token')
  const isUnRegisteredRoute = isSignInSignUpPage(to.name)

  const typeAction = getTypeAction(token, isUnRegisteredRoute)
  const redirect = {
    [config.tokenExpiredUserRegisterRouter]: () => {
      if (to.matched[0].name === ROUTES.WILDCARD.name) {
        // This condition is required to make sure that users will see 404 page when they are unauthorized
        next()
        return
      }
      localStorage.setItem('redirect_url_path', to.fullPath)
      if (to.name !== ROUTES.SIGN_IN.name) {
        router.push({ name: ROUTES.SIGN_IN.name })
      }
    },
    [config.tokenNullUserUnregisterRouter]: () => next(),
    [config.tokenReadyUserUnregisterRouter]: () => next({ name: 'home' }),
    [config.tokenReadyUserRegisterRouter]: () => next()
  }

  if (localStorage.getItem(COMPLETE_SIGN_UP_STEP)) {
    if (!isUnRegisteredRoute) {
      router.push(ROUTES.COMPLETE_SIGN_UP.name)
    }
    next()
  } else {
    redirect[typeAction]()
  }
})

export default router
